var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("已通过新窗口打开")])
}
var staticRenderFns = []

export { render, staticRenderFns }